module.exports = __webpack_public_path__ + "static/media/Illus-Outpost_1@2x.335bf09c.png";